import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  ignorePaths = [/memorabidevent\/.*/, /auctionView\/gethistory/];

  constructor(private translate: TranslateService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((httpErrorResponse: HttpErrorResponse) => {
        if (this.ignorePaths.some((path) => path.test(request.url))) {
          return throwError(() => httpErrorResponse);
        }
        if (httpErrorResponse.status == 501) {
          Swal.fire(
            this.translate.instant(httpErrorResponse.error.message),
            '',
            'error'
          );
        } else if (httpErrorResponse.status >= 500) {
          if (
            httpErrorResponse.error.message !== undefined &&
            httpErrorResponse.error.message.substring(0, 5) == '23505' &&
            httpErrorResponse.error.message.includes('slug')
          ) {
            Swal.fire(
              this.translate.instant('IDS_SLUG_ALREADY_EXISTS'),
              '',
              'error'
            );
          } else {
            Swal.fire(
              "È stato riscontrato un errore nella richiesta. Riprova o contattare l'assistenza."
            );
          }
        } else if (httpErrorResponse.status >= 404) {
          Swal.fire('Contenuto non disponibile.');
        }

        return throwError(() => httpErrorResponse);
      })
    );
  }
}
